(ns io.daskul.tutorial.webapp.domain.auth.subs
  "Authentication subscriptions."
  (:require
   [clojure.string :as str]
   [re-frame.core :as rf]))

(defn- decode-jwt-payload
  "Decode JWT payload (middle part). Returns nil if invalid."
  [token]
  (try
    (let [payload (-> token (str/split #"\.") second)]
      (-> payload
          js/atob
          js/JSON.parse
          (js->clj :keywordize-keys true)))
    (catch :default _
      nil)))

(defn- token-expired?
  "Check if JWT token is expired. Returns true if expired or invalid."
  [token]
  (if-let [payload (decode-jwt-payload token)]
    (let [exp (:exp payload)
          now (/ (.now js/Date) 1000)]
      (or (nil? exp) (< exp now)))
    true))

(rf/reg-sub
 ::token
 (fn [db _]
   (get-in db [:auth :token])))

(rf/reg-sub
 ::authenticated?
 :<- [::token]
 (fn [token _]
   (and (some? token)
        (not (token-expired? token)))))

(rf/reg-sub
 ::loading?
 (fn [db _]
   (get-in db [:auth :loading?])))

(rf/reg-sub
 ::error
 (fn [db _]
   (get-in db [:auth :error])))

;; Seconds remaining on a login rate-limit lockout (SMS-280), or nil when not
;; throttled. Ticks down once per second via ::throttle-tick.
(rf/reg-sub
 ::retry-after
 (fn [db _]
   (get-in db [:auth :retry-after])))

;; Current user info decoded from JWT
;; Returns: {:id, :email, :first-name, :last-name, :role, :school-id, :branch-id}
(rf/reg-sub
 ::current-user
 :<- [::token]
 (fn [token _]
   (when token
     (decode-jwt-payload token))))

;; Current user's role
(rf/reg-sub
 ::role
 :<- [::current-user]
 (fn [user _]
   (:role user)))

;; True when logged in via impersonation (admin API key)
(rf/reg-sub
 ::impersonating?
 :<- [::current-user]
 (fn [user _]
   (some? (:impersonator user))))

;; SMS-49: timezone map carried in the JWT — {<school-id> <tz>}.
;; Used by the calendar to render block times in the school's tz instead
;; of the browser's. Keys are stringified UUIDs (JWT JSON).
(rf/reg-sub
 ::school-timezones
 :<- [::current-user]
 (fn [user _]
   (:school-timezones user)))

;; #715: operating-days map carried in the JWT — {<org-unit-id> [day-name …]}.
;; Lets the week view drop columns for days a branch is shut. Keys are
;; stringified UUIDs (JWT JSON); values are lowercase day names.
(rf/reg-sub
 ::branch-operating-days
 :<- [::current-user]
 (fn [user _]
   (:branch-operating-days user)))
